import type { DocumentChecklistItem } from './criminalMasterData';

const DEFAULT_CHECKLIST: DocumentChecklistItem[] = [
  { id: 'signed-agreement', documentTypeId: 'signed-agreement', name: 'Signed Agreement', mandatory: false },
  { id: 'auth-docs', documentTypeId: 'auth-docs', name: 'Authorization Docs', mandatory: false },
  { id: 'cert-inc', documentTypeId: 'cert-inc', name: 'Certificate of Incorporation', mandatory: false },
];

export function getCivilAdviseDocumentChecklist(_subFileCategoryId?: string): DocumentChecklistItem[] {
  return DEFAULT_CHECKLIST.map((d) => ({ ...d }));
}
